export default {
    VARIANTS: {
        FULL: 'full',
        LINK_ONLY: 'linkOnly',
        NO_TITLE: 'noTitle',
        ICON_ONLY: 'iconOnly'
    },
    FEDEX_ONSITE: 'FEDEX_OFFICE'
};
